import { render } from "./billing.vue?vue&type=template&id=4cfdc956&scoped=true"
import script from "./billing.vue?vue&type=script&lang=js"
export * from "./billing.vue?vue&type=script&lang=js"

import "../less/profileSettings.less?vue&type=style&index=0&id=4cfdc956&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cfdc956"]])

export default __exports__